export function loadZendeskScript(key: string) {
  return new Promise<void>((resolve, reject) => {
    const script = document.createElement('script');
    script.id = 'ze-snippet';
    script.src = `https://static.zdassets.com/ekr/snippet.js?key=${key}`;
    script.async = true;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error('Failed to load Zendesk script'));
    document.body.appendChild(script);
  });
}
